import { create } from 'zustand'

interface FormSendStatusState {
    // store_id -> { form_id: status }
    sentFormsMap: Record<string, Record<string, number>>
    markFormSent: (store_id: string, form_id: string, status: number) => void
}

export const useFormSendStatusStore = create<FormSendStatusState>((set) => ({
    sentFormsMap: {},
    markFormSent: (store_id, form_id, status) => {
        set((state) => ({
            sentFormsMap: {
                ...state.sentFormsMap,
                [store_id]: {
                    ...state.sentFormsMap[store_id],
                    [form_id]: status,
                },
            },
        }))
    },
}))
